import { combineReducers } from 'redux';
import stations from './stations';
import organizations from './organizations';
import users from './users';
import sessions from './sessions';
import homepage from './homepage';
import contracts from './contracts';
import offers from './offers';
import authorization from './authorization';
import certificates from './certificates';
import collaterals from './collaterals';
import productionData from './productionData';
import utilities from './utilities';
import bilateralAgreements from './bilateralAgreements';
import redemptions from './redemptions';
import reconciliation from './reconciliation';
import gddk from './gddk';
import objections from './objections';
import operationHistory from './operationHistory';
import notification from './notification';
import portal from './portal';
import geo from './geo';
import intraSeanceCollaterals from './intraSeanceCollaterals'

const rootReducer = combineReducers({
  stations,
  organizations,
  users,
  authorization,
  homepage,
  certificates,
  collaterals,
  sessions,
  productionData,
  utilities,
  bilateralAgreements,
  redemptions,
  contracts,
  offers,
  reconciliation,
  objections,
  gddk,
  operationHistory,
  notification,
  portal,
  geo,
  intraSeanceCollaterals
});

export default rootReducer;
